import SHARED_TYPES from '@/modules/shared/types';

// Domain
import { CustomerNotificationRepository } from '../../../domain/repositories';
import { CustomerNotification } from '../../../domain/entities';
import Injectable from '@/modules/shared/domain/di/injectable';
import Inject from '@/modules/shared/domain/di/inject';
import HttpConnector from '@/modules/shared/domain/connectors/http';

@Injectable()
export default class CustomerNotificationHttpRepository implements CustomerNotificationRepository {
  @Inject(SHARED_TYPES.HTTP_CONNECTOR)
  private readonly http_connector!: HttpConnector;

  private readonly endpoint = `${process.env.VUE_APP_API_URL}/api/v1/app/dashboard/customer-notification/`

  get_notifications(): Promise<Array<CustomerNotification>> {
    return new Promise((resolve, reject) => {
      this.http_connector.execute(this.endpoint)
        .then((response) => {
          response.json()
            .then(({ success, data, message }) => {
              if (success) {
                resolve(data);
              }

              reject(new Error(message));
            });
        })
        .catch(reject);
    });
  }
}
